import cn from 'classnames'
import { Fragment } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'

import { HintComponent } from '../../../../HintComponent'
import { YoYField } from '../../../components/yoYField/YoYField'
import { IS_SHOW_PREV_PREV_FYEAR } from '../../../config'

import styles from './CategoryHeaderStandard.module.scss'

interface IProps {
  fyear: number
  translationKey: string
  isShowCalcActuals: boolean
  isShowFutureYears: boolean
  currentFQuarter: number
  isComposedReport: boolean
  periodFQuarters?: number[]
  isQbrYtd?: boolean
}

export const CategoryHeaderStandard = ({
  fyear,
  translationKey,
  isShowCalcActuals,
  isShowFutureYears,
  currentFQuarter,
  isComposedReport,
  periodFQuarters = [1, 2, 3, 4],
  isQbrYtd = false,
}: IProps) => {
  const fy = fyear % 100
  const prevFY = fy - 1
  const keyForQuarter = `${translationKey}-quarter`

  const isShowPrePreYear = IS_SHOW_PREV_PREV_FYEAR && !isComposedReport
  const yearlyColSpan = 4 + (isShowPrePreYear ? 1 : 0) + (isShowCalcActuals ? 1 : 0)
  const isShowYTD = isShowCalcActuals

  return (
    <>
      <tr key={keyForQuarter}>
        <th className={styles.quarterCell}></th>
        <th className={cn(styles.quarterCell, styles.colSeparator2)} colSpan={yearlyColSpan}>
          <div className={styles.quarterContainer}>
            <Translation text="jbp-planning-yearly" span actionsInside />
          </div>
        </th>
        {periodFQuarters.map((q) => {
          return (
            <th key={q} className={cn(styles.quarterCell, styles.colSeparator2)} colSpan={3}>
              <div className={styles.quarterContainer}>Q{q}</div>
            </th>
          )
        })}
        {isShowFutureYears && (
          <th className={cn(styles.quarterCell, styles.colSeparator2)} colSpan={yearlyColSpan}>
            <div className={styles.quarterContainer}>
              <Translation text="jbp-planning-yearly" span actionsInside />
            </div>
          </th>
        )}
      </tr>

      <tr key={translationKey}>
        <th className={styles.titleCell}>
          <Translation text="jbp-hrtargets-layer" span actionsInside />
        </th>

        {isShowPrePreYear && (
          <th className={cn(styles.tableCell, styles.colSeparator)}>
            <div className={styles.noWrapCell}>
              <div>FY{prevFY - 1}</div>
              <div>
                {isQbrYtd && (
                  <>
                    &nbsp;
                    <Translation text="jbp-planning-qbr-ytd" span actionsInside />
                  </>
                )}
              </div>
            </div>
          </th>
        )}
        {isShowCalcActuals && (
          <th className={cn(styles.tableCell, styles.colSeparator)}>
            <div className={styles.noWrapCell}>
              <div>FY{prevFY}*</div>
              <div>
                {isQbrYtd && (
                  <>
                    &nbsp;
                    <Translation text="jbp-planning-qbr-ytd" span actionsInside />
                  </>
                )}
              </div>
              <div className={styles.hintWrapper}>
                <HintComponent text="jbp-planning-calc-actuals-hint" />
              </div>
            </div>
          </th>
        )}
        <th
          className={cn(
            styles.tableCell,
            {
              [styles.colSeparator]: !isShowCalcActuals,
            },
            {
              [styles.colSeparatorThin]: isShowCalcActuals,
            }
          )}
        >
          <div className={styles.noWrapCell}>
            <div>FY{prevFY}</div>
            <div>{isShowYTD && <>&nbsp;YTD</>}</div>
            <div>
              {isQbrYtd && (
                <>
                  &nbsp;
                  <Translation text="jbp-planning-qbr-ytd" span actionsInside />
                </>
              )}
            </div>
          </div>
        </th>
        <th className={styles.yoyCell}>
          <YoYField />
        </th>

        <th className={cn(styles.tableCell, styles.colSeparator)}>
          <div className={styles.noWrapCell}>
            <div>FY{fy}</div>
            <div>
              {isQbrYtd && (
                <>
                  &nbsp;
                  <Translation text="jbp-planning-qbr-ytd" span actionsInside />
                </>
              )}
            </div>
          </div>
        </th>
        <th className={styles.yoyCell}>
          <div className={styles.noWrapCell}>
            <YoYField />
            <div>{isShowYTD && <>*</>}</div>
          </div>
        </th>

        {periodFQuarters.map((fq) => {
          const isShowQuarterYTD = isShowCalcActuals && fq >= currentFQuarter

          return (
            <Fragment key={fq}>
              <th className={cn(styles.tableCell, styles.colSeparator)}>
                <div className={styles.noWrapCell}>
                  <div>FY{prevFY}</div>
                  <div>{isShowQuarterYTD && <>&nbsp;YTD</>}</div>
                </div>
              </th>
              <th className={cn(styles.tableCell)}>FY{fy}</th>
              <th className={cn(styles.yoyCell)}>
                <YoYField />
              </th>
            </Fragment>
          )
        })}

        {isShowFutureYears && (
          <>
            <th className={cn(styles.tableCell, styles.colSeparator)}>
              <div className={styles.noWrapCell}>
                <div>FY{fy + 1}</div>
              </div>
            </th>
            <th className={styles.yoyCell}>
              <div className={styles.noWrapCell}>
                <YoYField />
              </div>
            </th>
            <th className={cn(styles.tableCell, styles.colSeparator)}>
              <div className={styles.noWrapCell}>
                <div>FY{fy + 2}</div>
              </div>
            </th>
            <th className={styles.yoyCell}>
              <div className={styles.noWrapCell}>
                <YoYField />
              </div>
            </th>
          </>
        )}
      </tr>
    </>
  )
}
